import { 
  SET_TOURNAMENT_MANAGER_EDITING,
  SET_TOURNAMENT_MANAGERS_IN_STATE,
  SET_TOURNAMENT_ADMINISTRATOR_EDITING,
  SET_TOURNAMENT_ADMINISTRATORS_IN_STATE
} from "./constants";

export const initialState = {
  managers: [],
  administrators: []
};

const reducer = (state = initialState, {type, payload}) => {
  switch (type) { 
    case SET_TOURNAMENT_MANAGERS_IN_STATE: {
      const managers = payload || initialState.managers;

      // Add editing flag
      managers.forEach(m => m.editing = false);

      return {
        ...state,
        managers: managers
      };
    }
    case SET_TOURNAMENT_MANAGER_EDITING: {
      return {
        ...state,
        managers: state.managers.map(m => {
          return m.id == payload ? {...m, editing: !m.editing} : {...m, editing: false};
        })
      };
    }

    case SET_TOURNAMENT_ADMINISTRATORS_IN_STATE: {
      const administrators = payload || initialState.administrators;

      // Add editing flag
      administrators.forEach(m => m.editing = false);

      return {
        ...state,
        administrators: administrators
      };
    }
    case SET_TOURNAMENT_ADMINISTRATOR_EDITING: {
      return {
        ...state,
        administrators: state.administrators.map(m => {
          return m.id == payload ? {...m, editing: !m.editing} : {...m, editing: false};
        })
      };
    }

    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/features/tournament/permissions/reducer.js